export const ValidateCMSObject = CmsObject => {
	let errors = [];
	//Description
	if (CmsObject.Description === null || CmsObject.Description === '') {
		errors.push(
			new CMSObjectError('Description', 'Description cannot be blank')
		);
	}

	if (CmsObject.Description && CmsObject.Description.length > 50) {
		errors.push(
			new CMSObjectError(
				'Description',
				'Description must be 50 characters or less'
			)
		);
	}

	//Fields
	CmsObject.Fields.forEach(field => {
		if (field.FieldDefinition.IsRequired) {
			
			if (
				!field.PendingUpdateApprovalValue ||
				field.PendingUpdateApprovalValue === ''
			) {
				errors.push(
					new CMSObjectError(
						`field:${field.FieldDefinition.Label}`,
						`${field.FieldDefinition.Label} cannot be blank`
					)
				);
			}
		}
	});

	return errors;
};

class CMSObjectError {
	constructor(field, message) {
		this.field = field;
		this.message = message;
	}
}
